module.exports = __webpack_public_path__ + "static/017-83019c1eb82e96ce8fccdfb63d8ae8bb.png";